import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AccountService } from "./api-account.service";
import { RequestPasswordCommand } from "../models/command/RequestPasswordCommand";
import { UpdatePasswordCommand } from "../models/command/UpdatePasswordCommand";

@Injectable({
  providedIn: 'root'
})

export class AccountDataService {

  constructor(private api: AccountService) {
  }

  public ConfirmeCodigo(command: RequestPasswordCommand): Observable<any> {
    return this.api.ConfirmeCodigo(command);
  }

  public AtualizaSenha(command: UpdatePasswordCommand): Observable<any> {
    return this.api.AtualizaSenha(command);
  }

}
